module.exports = "dist/c3731ef75b988834ff688c68fdf5b16a.png";